import { Box, Button, CardMedia, Chip, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Cart, LeftArrow, RightArrow, StarIcon, Wishlist } from '../../../Svg'
import ProductDetails from './ProductDetails/ProductDetails'
import { useDispatch, useSelector } from 'react-redux'
import { addCarts, addWishlist, getAllWishlist } from '../../../redux/wishlistSlice'
import { useNavigate } from 'react-router-dom'
import { setVisible } from '../../../redux/authModelSlice'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import Styles from '../prodDescription/ProductDetails/productdetails.module.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ForkLeftRounded, KeyboardArrowLeftSharp, KeyboardArrowRight, KeyboardArrowRightSharp } from '@mui/icons-material';
import Toastify from "../../../helper/Toastify";
import Loader from '../../components/Loader/Loader';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';


const CustomArrow = ({ className, onClick, arrowDirection }) => {
    return (
        <div
            className={`${className} ${Styles.customArrow} ${arrowDirection === "left" ? Styles.leftArrow : Styles.rightArrow
                }`}
            onClick={onClick}
        >
            {arrowDirection === "left" ? <LeftArrow /> : <RightArrow />}
        </div>
    );
};
const ProdDetail = ({ productsByIdData, formatPrice }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const { isLoggedIn } = useSelector((state) => state.user)
    const { wishlistData } = useSelector((state) => state.wishlist)
    const wishlistRefresh = useSelector((state) => state.wishlist.isRefresh);
    const { isLoading } = useSelector((state) => state.products);

    const [isIOS, setIsIOS] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    useEffect(() => {
        const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        setIsIOS(isAppleDevice);
    }, []);

    useEffect(() => {
        if (isModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isModalOpen]);

    const isWishlisted = Array.isArray(wishlistData)
        ? wishlistData.some((item) => item?.productId === productsByIdData?.product?._id)
        : false

    useEffect(() => {
        dispatch(getAllWishlist())

    }, [dispatch, wishlistRefresh])

    const handleWishlist = async (value) => {

        let data = {
            productId: value,
            quantity: 1
        }
        dispatch(addWishlist(data))

    }

    const [selectedValue, setSelectedValue] = useState("Fully Paid");
    const [isAdding, setIsAdding] = useState(false);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };
    const [quantity, setQuantity] = useState(1);

    const advancePayment = productsByIdData?.sellingPrice / 2
    const fullPriceWithQuantiy = productsByIdData?.sellingPrice;
    const totalPriceWithQuantity = productsByIdData?.totalPrice;

    const productDetail = { ...productsByIdData, quantity }

    const data = {
        state: productsByIdData,
        quantity: quantity,
        selectedValue: selectedValue,
        advancePayment: advancePayment,
        product: [productDetail]
    }

    const [currentIndex, setCurrentIndex] = useState(0);
    const photos = productsByIdData?.product?.media?.photo || [];
    const scrollRef = useRef(null);

    const scrollLeft = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prev => prev - 1);
            const container = scrollRef.current;
            const scrollAmount = container.offsetWidth;
            container.scrollLeft -= scrollAmount;
        }
    };

    const scrollRight = () => {
        if (currentIndex < photos.length - 1) {
            setCurrentIndex(prev => prev + 1);
            const container = scrollRef.current;
            const scrollAmount = container.offsetWidth;
            container.scrollLeft += scrollAmount;
        }
    };



    const handlePlaceOrder = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isLoggedIn) {
            navigate(`/checkout`, { state: data })
        } else {
            dispatch(setVisible('signin'))
        }
    };

    const addToCartHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!isLoggedIn) {
            dispatch(setVisible('signin'));
            return;
        }
        if (isAdding) return;
        setIsAdding(true);
        try {
            const id = productsByIdData?.product?._id;
            const body = {
                productId: id,
                quantity: 1,
            };
            dispatch(addCarts(body));
        } catch (err) {
            console.log(err);
        } finally {
            setIsAdding(false);
        }
    };

    if (!productsByIdData || isLoading) {
        return <Loader />;
    }

    return (
        <>

            <Box display="flex" alignItems="flex-start" justifyContent="flex-start"
                gap={7} paddingLeft={10} paddingRight={10} my={5}
                sx={{
                    "@media (max-width: 768px)": {
                        flexDirection: "column",
                        gap: '40px',
                        alignItems: 'flex-start',
                        padding: '30px',
                        justifyContent: 'flex-start',
                        margin: '0px'
                    },
                    "@media (max-width: 425px)": {
                        padding: '20px',

                    },

                }}
            >
                <Box sx={{ flex: '0 0 50%' }}>
                    {/* Image grid */}
                    <Grid>
                        <div className={Styles.sliderWrapper}>
                            {photos.length > 1 && currentIndex > 0 && (
                                <button type="button" className={Styles.leftArrow} onClick={scrollLeft}>
                                    {/* <LeftArrow fontSize="small" /> */}
                                    <KeyboardArrowLeftSharp />
                                </button>
                            )}

                            <div className={Styles.sliderContainer} ref={scrollRef}>
                                {photos.map((item, index) => (
                                    <div className={Styles.catStatusStyle} key={index}>
                                        {isIOS ? (
                                            <div
                                                className={Styles.fullscreenContainer}
                                                onClick={() => {
                                                    setCurrentImage(item);
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <img
                                                    src={item}
                                                    className={Styles.sliderImage}
                                                    alt={`Product ${index + 1}`}
                                                />
                                            </div>
                                        ) : (
                                            <Zoom
                                                wrapStyle={{
                                                    display: 'block',
                                                    width: '100%',
                                                    height: '100%',
                                                    position: 'relative',
                                                    transform: 'translateZ(0)'
                                                }}
                                                overlayBgColorEnd="rgba(0, 0, 0, 0.95)"
                                                transitionDuration={300}
                                                shouldHandleZoom={(e) => e.type !== 'touchend'}
                                                shouldReplaceImage={false}
                                            >
                                                <CardMedia
                                                    image={item}
                                                    className={Styles.sliderImage}
                                                    component="img"
                                                    style={{
                                                        cursor: 'pointer',
                                                        display: 'block',
                                                        width: '100%',
                                                        height: '100%',
                                                        transform: 'translate3d(0,0,0)'
                                                    }}
                                                    onTouchStart={(e) => e.preventDefault()}
                                                />
                                            </Zoom>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {photos.length > 1 && currentIndex < photos.length - 1 && (
                                <button type="button" className={Styles.rightArrow} onClick={scrollRight}>
                                    <KeyboardArrowRightSharp />
                                </button>
                            )}
                        </div>
                    </Grid>

                    {/* Video */}
                    {productsByIdData?.product?.media?.video?.[0]?.trim() ? (
                        <Box sx={{
                            position: 'relative',
                            width: '98%',
                            height: '340px',
                            overflow: 'hidden',
                            backgroundColor: '#000',
                            marginTop: '16px',
                            "@media (max-width: 786px)": {
                                height: '200px',
                            }
                        }}
                        >
                            <Box
                                component="video"
                                src={productsByIdData?.product?.media?.video[0]}
                                autoPlay
                                loop
                                muted
                                playsInline
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </Box>
                    ) : null}
                </Box>

                <Box sx={{ flex: '0 0 46%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Chip
                            label={productsByIdData?.product?.gold?.orderType === 'Ready to ship orders' ? 'Ready to ship' : 'Made to order'}
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                borderRadius: '0px',
                                height: '26px',
                                fontSize: '12px',
                                border: '1px solid #00000033',
                                background: '#fff'
                            }}
                        />

                    </Box>

                    <Typography mt={2}
                        sx={{
                            fontSize: '36px',
                            color: '#000',
                            fontWeight: 500,
                            lineHeight: '38px',
                            "@media (max-width: 768px)": {
                                fontSize: '30px'
                            },
                            "@media (min-width: 768px)": {
                                fontSize: '24px',
                            },
                        }}
                    >
                        {productsByIdData?.product?.productName}
                        {/* {productsByIdData?.product?.inventory?.sku === null ? (
                            null
                        ) : (
                            <Typography mt={1}
                                sx={{
                                    fontSize: '16px',
                                    color: '#000',
                                    fontWeight: 500,
                                    lineHeight: '',

                                }}>
                                Product Id: {productsByIdData?.product?.inventory?.sku}
                            </Typography>
                        )} */}
                    </Typography>

                    <Typography mt={2} sx={{ fontSize: '24px', color: '#000', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {formatPrice(fullPriceWithQuantiy)}
                        {productsByIdData?.mrpdiscount === 0 ? (
                            null
                        ) : (
                            <Typography
                                sx={{ fontSize: '20px', color: '#00000099', fontWeight: 500, textDecoration: 'line-through', }}>
                                {formatPrice(totalPriceWithQuantity)}
                            </Typography>
                        )}
                    </Typography>

                    {/* {productsByIdData?.averageRating?.length > 0 && (<Box mt={1} sx={{ display: 'flex', alignItems: 'center', marginBottom: 2, gap: '6px' }}>
                        {Array.from({ length: productsByIdData?.averageRating }).map((_, index) => (
                            <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                <StarIcon />
                            </Box>
                        ))}
                        <Typography sx={{ fontSize: '16px', color: '#00000099', fontWeight: 500, }}>
                            {productsByIdData?.averageRating}
                        </Typography>
                    </Box>
                    )} */}

                    {productsByIdData?.product?.gold?.orderType === 'Made to orders' && (
                        <Box mt={1} sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: "column", marginBottom: 2, gap: '6px' }}>
                            <Typography sx={{
                                color: '#000',
                                fontSize: '22px',
                                textAlign: 'center',
                                marginRight: '10px',
                                fontWeight: '800',
                                marginTop: "10px"
                            }}>
                                Payment option
                            </Typography>
                            <RadioGroup value={selectedValue} onChange={handleChange}>
                                <FormControlLabel
                                    value="Fully Paid"
                                    control={<Radio sx={{ padding: '6px', "&.Mui-checked": { color: "#ff5722", }, }} />}
                                    label={
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                '@media (max-width:340px)': { fontSize: '13px' },
                                            }}
                                        >
                                            Full Payment
                                        </Typography>
                                    }
                                />
                                <FormControlLabel
                                    value="Ad Paid"
                                    control={<Radio sx={{ padding: '6px', "&.Mui-checked": { color: "#ff5722", }, }} />}
                                    label={
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                '@media (max-width:340px)': { fontSize: '13px' }, 
                                            }}
                                        >
                                            Advance payment (50%){' '}
                                            <Typography sx={{
                                                backgroundColor: '#fff',
                                                color: '#000',
                                                borderRadius: '0px',
                                                fontSize: '12px',
                                                border: '1px solid #00000033',
                                                background: '#fff',
                                                textAlign: 'center',
                                                padding: '4px 6px 2px 6px',
                                            }}>
                                                {formatPrice(advancePayment)}
                                            </Typography>
                                        </Box>
                                    }
                                />
                            </RadioGroup>
                            {selectedValue === 'Ad Paid' && (
                                <Typography sx={{
                                    color: '#f71313',
                                    fontSize: '12px',
                                    fontFamily: 'karla',
                                    fontWeight: 500
                                }}>
                                    Minimum 25 Days required and 5 Days of Shipping. Price may increase or decrease according to the Weight, when a new product is made.
                                </Typography>
                            )}
                            <div></div>
                        </Box>
                    )}

                    <div className={Styles.wishCartBtnsCont}>
                        <img src='/hallmark.png' alt='hallmark' />
                        <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (isLoggedIn) {
                                handleWishlist(productsByIdData?.product?._id);
                            } else {
                                dispatch(setVisible('signin'))
                            }
                        }}
                          className={Styles.addToCartText}
                        >
                            <Wishlist color={isWishlisted ? 'red' : 'white'} borderColor={isWishlisted ? 'red' : 'black'} /> Add to wishlist
                        </div>
                        <div onClick={addToCartHandler} className={Styles.addToCartText}>
                            <Cart /> {isAdding ? 'Adding...' : 'Add to cart'}
                        </div>
                    </div>


                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#FF682180',
                            color: 'black',
                            padding: 1.5,
                            fontWeight: 'bold',
                            textTransform: 'none',
                            borderRadius: 2,
                            width: '100%',
                            marginTop: '20px',
                            boxShadow: 'none'
                        }}
                        onClick={handlePlaceOrder}
                    >
                        Place Order
                    </Button>

                    {productsByIdData?.product?.gold?.orderType === 'Made to orders' && (
                        <Typography
                            variant="body2"
                            sx={{
                                marginTop: 2,
                                fontStyle: 'bold',
                                color: 'gray',
                                fontSize: '13px',
                                fontWeight: '1000'
                            }}
                        >
                            Note: Advance payment required. Balance due to be paid before Shipping.
                        </Typography>
                    )}
                    
                    <Box display="flex" alignItems="flex-start" justifyContent="center" gap={6} mt={2}>
                        <ProductDetails productDetails={productsByIdData} />
                    </Box>
                </Box >

                {isIOS && isModalOpen && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.95)',
                            zIndex: 9999,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        onClick={() => setIsModalOpen(false)}
                    >
                        <button
                            style={{
                                position: 'absolute',
                                top: 20,
                                right: 40,
                                background: 'none',
                                border: 'none',
                                color: 'white',
                                fontSize: 24,
                                cursor: 'pointer',
                                zIndex: 10000
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsModalOpen(false);
                            }}
                        >
                            ✕
                        </button>
                        <div onClick={e => e.stopPropagation()}>
                            <TransformWrapper
                                initialScale={1}
                                minScale={0.5}
                                maxScale={4}
                                centerOnInit={true}
                            >
                                {({ zoomIn, zoomOut, resetTransform }) => (
                                    <>
                                        <div style={{
                                            position: 'absolute',
                                            top: 20,
                                            left: 20,
                                            zIndex: 10000,
                                            display: 'flex',
                                            gap: '10px'
                                        }}>
                                            <button onClick={() => zoomIn()} style={{ background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px' }}>+</button>
                                            <button onClick={() => zoomOut()} style={{ background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px' }}>-</button>
                                            <button onClick={() => resetTransform()} style={{ background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px' }}>Reset</button>
                                        </div>
                                        <TransformComponent
                                            wrapperStyle={{
                                                width: '100vw',
                                                height: '100vh'
                                            }}
                                            contentStyle={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <img
                                                src={currentImage}
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    objectFit: 'contain'
                                                }}
                                                alt="Enlarged product"
                                            />
                                        </TransformComponent>
                                    </>
                                )}
                            </TransformWrapper>
                        </div>
                    </div>
                )}

            </Box>
        </>
    )
}

export default ProdDetail